var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NextReviewerModal",
    {
      ref: "modal",
      attrs: {
        asyncSelectOptions: _vm.getInspectorOptions,
        okBtnAction: "confirm",
        okBtnDisabled: !_vm.selectedValue,
        title: "Please Select Inspector",
      },
      on: { onOkClick: _vm.save },
    },
    [
      _vm.showInspectorEmptyHint
        ? _c("template", { slot: "add-text" }, [
            _c("p", { staticClass: "error-hint" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("hint.noInspector")) + "\n    "
              ),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }